import type { DashboardLayout, DashboardLayoutItem, DashboardReportMeta } from "../../types/api";

export function buildDefaultLayout(reports: DashboardReportMeta[]): DashboardLayout {
  const sorted = [...reports].sort((a, b) => a.sort_order - b.sort_order);
  const items: DashboardLayoutItem[] = [];
  let x = 0;
  let y = 0;
  let rowHeight = 1;

  for (const report of sorted) {
    if (x + report.colspan > 12) {
      x = 0;
      y += rowHeight;
      rowHeight = report.rowspan;
    }
    items.push({
      report_key: report.key,
      colspan: report.colspan,
      rowspan: report.rowspan,
      x,
      y,
    });
    rowHeight = Math.max(rowHeight, report.rowspan);
    x += report.colspan;
    if (x >= 12) {
      x = 0;
      y += rowHeight;
      rowHeight = 1;
    }
  }

  return { version: 1, columns: 12, items };
}

export function nextLayoutSlot(
  items: DashboardLayoutItem[],
  colspan: number,
  rowspan: number,
): Pick<DashboardLayoutItem, "x" | "y" | "colspan" | "rowspan"> {
  const y = items.reduce((max, item) => Math.max(max, item.y + item.rowspan), 0);
  return { x: 0, y, colspan, rowspan };
}

export function addReportToLayout(
  layout: DashboardLayout,
  report: Pick<DashboardReportMeta, "key" | "colspan" | "rowspan">,
): DashboardLayout {
  if (layout.items.some((item) => item.report_key === report.key)) {
    return layout;
  }
  const slot = nextLayoutSlot(layout.items, report.colspan, report.rowspan);
  return {
    ...layout,
    items: [
      ...layout.items,
      {
        report_key: report.key,
        ...slot,
      },
    ],
  };
}

export function removeReportFromLayout(layout: DashboardLayout, reportKey: string): DashboardLayout {
  return {
    ...layout,
    items: layout.items.filter((item) => item.report_key !== reportKey),
  };
}

export function gridBottomPadding(items: DashboardLayoutItem[], _rowHeight: number, marginY: number): number {
  if (items.length === 0) return 80;
  const maxRow = items.reduce((max, item) => Math.max(max, item.y + item.rowspan), 0);
  return maxRow * marginY + 96;
}
